import { clearAllBodyScrollLocks } from 'body-scroll-lock';
import throttle from 'lodash/throttle';

const openEvent = new Event('button-dropdown-opened');
const closeEventButtonDropdown = new Event('button-dropdown-closed');
//const closeEventButtonDropdown = new Event('navigation-closed');

// const scrollableElements = document.querySelectorAll(
// 	'.block-button-dropdown .block-navigation__menu, .block-button-dropdown.is-style-full-width-dropdown .block-navigation-submenu'
// );

const navigationBlocks = document.querySelectorAll('.block-button-dropdown');

const navigationHamburgers = document.querySelectorAll(
	'.block-button-dropdown .block-navigation__hamburger'
);

const toggleNavigationHamburger = (e) => {
	const currentNavigationHamburger = e?.currentTarget ?? e;
	currentNavigationHamburger.classList.toggle('active');

	if (currentNavigationHamburger.classList.contains('active')) {
		window.dispatchEvent(openEvent);
		setFirstLevelButtonBlockOffsets();
		setNavMenuActiveClass(currentNavigationHamburger, true);
		currentNavigationHamburger.setAttribute('aria-expanded', true);

		// if (window.innerWidth < 992) {
		// 	lockScroll();
		// }
	} else {
		window.dispatchEvent(closeEventButtonDropdown);

		clearAllBodyScrollLocks();

		setNavMenuActiveClass(currentNavigationHamburger, false);
		currentNavigationHamburger.setAttribute('aria-expanded', false);
	}
};

const toggleNavigationDropdownBlock = (e) => {
	const currentNavigationDropdownBlock = e?.currentTarget ?? e;
	currentNavigationDropdownBlock.classList.toggle('active');

	if (currentNavigationDropdownBlock.classList.contains('active')) {
		window.dispatchEvent(openEvent);
		//setFirstLevelButtonBlockOffsets();
		setNavMenuActiveClass(currentNavigationDropdownBlock, true);
		currentNavigationDropdownBlock.setAttribute('aria-expanded', true);

		// if (window.innerWidth < 992) {
		// 	lockScroll();
		// }
	} else {
		window.dispatchEvent(closeEventButtonDropdown);

		clearAllBodyScrollLocks();

		setNavMenuActiveClass(currentNavigationDropdownBlock, false);
		currentNavigationDropdownBlock.setAttribute('aria-expanded', false);
	}
};

const submenuClosed = () => {
	if (window.innerWidth >= 992) {
		clearAllBodyScrollLocks();
	}
};

const setFirstLevelButtonBlockOffsets = () => {
	if (0 === navigationBlocks.length) {
		return;
	}

	navigationBlocks.forEach((navigationBlock) => {
		const firstLevelButtonBlocks = navigationBlock.querySelectorAll(
			'.block-button-dropdown .block-navigation__menu > .wp-block-button'
		);

		if (0 === firstLevelButtonBlocks.length) {
			return;
		}

		let totalOffset = 0;

		for (let i = firstLevelButtonBlocks.length - 1; i >= 0; i--) {
			const firstLevelButtonBlock = firstLevelButtonBlocks[i];

			firstLevelButtonBlock.style.setProperty(
				'--buttonOffset',
				`${totalOffset / 16}rem`
			);

			totalOffset += firstLevelButtonBlock.offsetHeight;
		}

		navigationBlock.style.setProperty(
			'--totalButtonOffset',
			`${totalOffset / 16}rem`
		);
	});
};

const setNavMenuActiveClass = (element, navActiveButtonDropdown = null) => {
	const currentElement = element?.detail?.currentElement ?? element;

	if (!currentElement) {
		return;
	}

	const currentNavigationBlock = currentElement.closest(
		'.block-button-dropdown'
	);

	if (!currentNavigationBlock) {
		return;
	}

	if (null === navActiveButtonDropdown) {
		if (
			currentElement.classList.contains('active') ||
			currentElement.parentElement.classList.contains('active') ||
			currentNavigationBlock.querySelector(
				'.block-button-dropdown .block-navigation__hamburger.active'
			)
		) {
			navActiveButtonDropdown = true;
		} else {
			navActiveButtonDropdown = false;
		}
	}

	if (true === navActiveButtonDropdown) {
		currentNavigationBlock.classList.add('active');
		document.addEventListener('keydown', clickOffMenu);
		document.addEventListener('click', clickOffMenu);
	} else {
		currentNavigationBlock.classList.remove('active');
		document.removeEventListener('keydown', clickOffMenu);
		document.removeEventListener('click', clickOffMenu);
	}

	navigationBlocks.forEach((navigationBlock) => {
		if (navigationBlock !== currentNavigationBlock) {
			navigationBlock.classList.remove('active');
		}
	});
};

// const lockScroll = () => {
// 	if (scrollableElements.length) {
// 		scrollableElements.forEach(function (scrollableElement) {
// 			const storedRequestAnimationFrame = window.requestAnimationFrame;
// 			window.requestAnimationFrame = () => 42;

// 			disableBodyScroll(scrollableElement, {
// 				reserveScrollBarGap: true,
// 			});
// 			window.requestAnimationFrame = storedRequestAnimationFrame;
// 		});
// 	}
// };

const clickOffMenu = (e) => {
	if (0 === navigationHamburgers.length) {
		return;
	}

	let closestMenu;
	let closestHamburger;

	if (e.key === undefined && e.target) {
		closestMenu = e.target.closest(
			'.block-button-dropdown .block-navigation__menu'
		);
		closestHamburger = e.target.closest(
			'.block-button-dropdown .block-navigation__hamburger'
		);
	}

	if (e.key && e.key !== 'Escape') {
		return;
	}

	if (
		closestMenu?.contains(e.target) ||
		closestHamburger?.contains(e.target)
	) {
		return;
	}

	navigationHamburgers.forEach((navigationHamburger) => {
		if (navigationHamburger.classList.contains('active')) {
			toggleNavigationHamburger(navigationHamburger);
		}
	});

	navigationBlocks.forEach((navigationBlock) => {
		if (navigationBlock.classList.contains('active')) {
			toggleNavigationDropdownBlock(navigationBlock);
		}
	});
	// eslint-disable-next-line no-console
	//console.log('clickOffMenu');

	window.dispatchEvent(closeEventButtonDropdown);
};

if (navigationHamburgers.length > 0) {
	navigationHamburgers.forEach((navigationHamburger) => {
		navigationHamburger.addEventListener(
			'click',
			toggleNavigationHamburger
		);
	});
}

// if (navigationBlocks.length > 0) {
// 	navigationBlocks.forEach((navigationBlock) => {
// 		navigationBlock.addEventListener(
// 			'click',
// 			toggleNavigationDropdownBlock
// 		);
// 	});
// }

setFirstLevelButtonBlockOffsets();

if (navigationBlocks.length > 0) {
	navigationBlocks.forEach((navigationBlock) => {
		navigationBlock.classList.add('block-button-dropdown--initialized');
	});
}

window.addEventListener('button-dropdown-submenu-closed', submenuClosed);
window.addEventListener(
	'button-dropdown-submenu-closed',
	setNavMenuActiveClass
);
window.addEventListener(
	'button-dropdown-submenu-opened',
	setNavMenuActiveClass
);
window.addEventListener(
	'resize',
	throttle(setFirstLevelButtonBlockOffsets, 100)
);
